import type { AddressValue, ArrayFact, ScalarFact } from "../types";

// Whether a lookup asked Google about this address and Google could not place
// it (#13126): the one case the amber marker shows. An address a connector
// composed and nobody has looked up is not flagged, and neither is one stored
// before the marker existed.
export function isAddressUnplaceable(
  value: AddressValue | null | undefined
): boolean {
  return value?.lookup_failed === true;
}

// Tooltip and accessible name of the amber marker, shown only on an
// address a lookup could not place.
export const UNPLACEABLE_ADDRESS_TOOLTIP = "Address could not be confirmed";

export interface AddressCoordinates {
  lat: number;
  lng: number;
}

export interface MappedAddress {
  formatted: string;
  coordinates: AddressCoordinates;
}

// The address a record-page map preview draws (#13870): a scalar address
// fact whose value carries numeric coordinates. A list value, a plain string
// (never validated) or a value whose lat/lng is null has nothing to map.
export function mappedAddressOf(
  fact: ScalarFact | ArrayFact
): MappedAddress | null {
  if ("array" in fact || fact.scalar_type !== "address") return null;
  const value: unknown = fact.scalar;
  if (value == null || typeof value !== "object" || Array.isArray(value)) {
    return null;
  }
  const { formatted, lat, lng } = value as AddressValue;
  if (typeof lat !== "number" || typeof lng !== "number") return null;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { formatted, coordinates: { lat, lng } };
}
